import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, UrlSerializer, provideRouter } from '@angular/router';
import { UserService } from './app/service/user.service';
import { TokenInterceptor } from './app/interceptor/token-interceptor.interceptor';
import { StorageService } from './app/service/storage.service';
import { GlobalErrorHandler } from './app/service/global-error-handler.service';
import { StateService } from './app/service/state.service';
import { LowerCaseUrlSerializerService } from './app/service/lower-case-url-serializer.service';
import { TranslocoHttpLoader } from './app/service/transloco-http-loader';
import { provideTransloco } from '@ngneat/transloco';
import { routes } from './app/app.routes';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { isDevMode } from '@angular/core';
import { DatePipe } from '@angular/common';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
      deps: [StorageService, ToastrService, StateService, Router],
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializerService },
    provideTransloco({
      config: {
        availableLangs: ['english', 'de', 'hindi'],
        defaultLang: 'english',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideToastr({
      progressBar: true,
      progressAnimation: 'decreasing',
      preventDuplicates: true,
      positionClass: 'toast-bottom-left',
    }),
    DatePipe,
    provideAnimations(),
  ]
}).catch(err => console.error(err));

